export default "__VITE_ASSET__BiJuIPhh__"